<template>
  <div class="PapelSegurancaLoteDetalhes">
    <div v-if="Object.values(lote).length > 0">
      <sub-header-grey class="pt-1 pb-1">
        <div class="row">
          <div class="col pt-1">
            <h5><label class="label">Lote {{ lote.prefixo_inicial }}{{ lote.numero_inicial }} - {{ lote.prefixo_final }}{{ lote.numero_final }}</label></h5>
          </div>
          <div class="col text-right">
            <button class="btn btn-sm btn-danger"
                    @click="deleteLote()">
              Excluir lote
            </button>
            <button class="btn btn-sm btn-primary ml-2"
                    @click="edicao.show = true">
              Editar lote
            </button>
          </div>
        </div>
      </sub-header-grey>

      <div class="row mt-3">
        <div class="col-2">
          <label class="label">
            Mostrar impresso
          </label>
          <select v-model="search.status"
                  class="form-control form-control-sm"
                  @change="reloadLoteItens()">
            <option value="USADO">
              Usados
            </option>
            <option value="ATIVO">
              Ativos
            </option>
            <option value="CANCELADO">
              Cancelados
            </option>
          </select>
        </div>
        <div class="col-4">
          <label class="label">
            Buscar impresso
          </label>
          <input v-model="search.numero_serie"
                 type="text"
                 class="form-control form-control-sm"
                 placeholder="Digite o número de série"
                 @change="reloadLoteItens()">
        </div>
        <div class="col-4 mt-4">
          <button class="btn btn-sm btn-outline-primary"
                  @click="resetBusca()">
            Limpar busca
          </button>
          <button class="btn btn-sm btn-danger ml-4"
                  @click="cancelarImpressos()">
            Cancelar não utilizados
          </button>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <b-table :fields="table.fields"
                   :items="itens"
                   :busy="table.busy"
                   class="text-left"
                   outlined
                   striped
                   thead-class="PapelSegurancaLoteDetalhes_table--header"
                   tbody-tr-class="thead-row-class"
                   show-empty>
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle mr-2 icon--sm" />

                <strong>Carregando...</strong>
              </div>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center">
                Sem registros
              </div>
            </template>
            <template slot="key_matricula"
                      slot-scope="data">
              <div>
                <b-link v-if="data.item.registro_id"
                        v-b-tooltip.hover.top="'Abrir registro em nova aba'"
                        target="_blank"
                        :to="getUrl(data.item)">
                  <span><b>{{ data.item.registro.matricula | maskMatricula() }}</b></span>
                </b-link>
                <span v-else>
                  <small>-</small>
                </span>
              </div>
            </template>
            <template slot="key_ordem_servico"
                      slot-scope="data">
              <div v-if="!!data.item.ordemServico">
                {{ data.item.ordemServico.numero }}
              </div>
              <div v-else>
                <span><small>-</small></span>
              </div>
            </template>
            <template slot="key_data_hora_consumo"
                      slot-scope="data">
              <div>
                {{ data.item.data_consumo ? data.item.data_consumo : null | dateHour }}
              </div>
            </template>
            <template slot="key_data_hora_cancelamento"
                      slot-scope="data">
              <div>
                {{ data.item.data_cancelamento ? data.item.data_cancelamento : null | dateHour }}
              </div>
            </template>
            <template slot="key_action"
                      slot-scope="data">
              <div>
                <button v-if="data.item.status != 'CANCELADO' && !data.item.data_informado_ws"
                        class="btn btn--xs btn-danger mr-2"
                        @click="showModalCancelar(data.item)">
                  Cancelar papel
                </button>
                <button v-if="data.item.status === 'CANCELADO'"
                        :disabled="data.item.data_informado_ws || data.item.status != 'CANCELADO'"
                        class="btn btn--xs btn-success mr-2"
                        @click="reutilizarPapel(data.item)">
                  Reutilizar papel
                </button>
                <button v-if="data.item.status !== 'ATIVO'"
                        class="btn btn--xs btn-outline-secondary"
                        :disabled="data.item.status == 'ATIVO'"
                        @click="showModalDetalhes(data.item)">
                  Mostrar detalhes
                </button>
              </div>
            </template>
          </b-table>

          <Pagination v-if="itens.length > 0"
                      :page="pagination.page"
                      :last-page="pagination.lastPage"
                      :select-page="true"
                      @onPreviousPage="changePage(pagination.page - 1)"
                      @onNextPage="changePage(pagination.page + 1)"
                      @onSetPage="page => changePage(page)" />
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <hr>
          <b-link class="btn btn-sm btn-outline-secondary"
                  :to="{ name: 'papel_seguranca_lote' }">
            Voltar
          </b-link>
        </div>
      </div>
    </div>

    <!-- modal cancelamento -->
    <b-modal v-if="modalCancelamento.show"
             visible
             no-close-on-backdrop
             no-close-on-esc
             centered
             size="md"
             hide-footer
             hide-header>
      <h5>Motivo cancelamento do papel <u>{{ modalCancelamento.item.numero_serie }}</u>:</h5>
      <b-form-group class="mt-2">
        <b-form-radio-group
          id="radio-group-1"
          v-model="modalCancelamento.item.motivo_cancelamento"
          stacked
          class="ml-3"
          :options="modalCancelamento.motivos"
          name="radio-options" />
      </b-form-group>
      <hr>
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-sm btn-outline-primary"
                  @click="hideModalCancelar()">
            Voltar
          </button>
          <button class="btn btn-sm btn-primary ml-2"
                  :disabled="!modalCancelamento.item.motivo_cancelamento"
                  @click="cancelItem()">
            Cancelar papel
          </button>
        </div>
      </div>
    </b-modal>

    <!-- modal detalhes -->
    <b-modal v-if="modalDetalhes.show"
             visible
             no-close-on-backdrop
             no-close-on-esc
             centered
             size="lg"
             hide-footer
             hide-header>
      <h5>Detalhes do papel <u>{{ modalDetalhes.item.numero_serie }}</u>:</h5>
      <hr>
      <div v-if="modalDetalhes.item.status == 'USADO'"
           class="row">
        <div class="col">
          <label class="label">Tipo de uso</label>
          <div>
            <span v-if="modalDetalhes.item.tipo_uso == 'PRIMEIRA'">
              1ª Via
            </span>
            <span v-if="modalDetalhes.item.tipo_uso == 'SEGUNDA'">
              2ª Via
            </span>
          </div>
        </div>
        <div class="col">
          <label class="label">Data/hora consumo</label>
          <div>
            {{ modalDetalhes.item.data_consumo ? modalDetalhes.item.data_consumo : null | dateHour }}
          </div>
        </div>
        <div class="col">
          <label class="label">Utilizado por</label>
          <div>
            {{ usuarios.find(user => user.user_id == modalDetalhes.item.usuario_id).nome || '' }}
          </div>
        </div>
      </div>
      <div v-if="modalDetalhes.item.status == 'CANCELADO'"
           class="row">
        <div class="col">
          <label class="label">Cancelado por</label>
          <div>
            {{ usuarios.find(user => user.user_id == modalDetalhes.item.usuario_id).nome || '' }}
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-sm btn-outline-primary"
                  @click="hideModalDetalhes()">
            Voltar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- edicao -->
    <papel-seguranca-lote-adicionar v-if="edicao.show"
                                    :prop-edit="true"
                                    :prop-lote="lote"
                                    @onSaveLote="lote => updateLote(lote)"
                                    @onCloseModal="edicao.show = false" />
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import Pagination from '@/components/SofiaRei/Pagination'
  import PapelSegurancaLoteAdicionar from "@/components/SofiaRei/PapelSeguranca/PapelSegurancaLote/PapelSegurancaLoteAdicionar"

  /* services */
  import PapelSegurancaLoteService from "@/services/PapelSeguranca/PapelSegurancaLoteService"
  import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* helpers */
  import ErrorsPapelSegurancaLoteHelper from "@/helpers/Errors/PapelSeguranca/ErrorsPapelSegurancaLoteHelper"

  export default {
    name: "PapelSegurancaLoteDetalhes",
    components: {
      SubHeaderGrey,
      Pagination,
      PapelSegurancaLoteAdicionar
    },
    props: {
      propLote: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        edicao: {
          show: false
        },
        usuarios: [],
        search: {
          status: 'USADO',
          numero_serie: null
        },
        pagination: {
          page: 1,
          perPage: 5,
          lastPage: null
        },
        modalCancelamento: {
          motivos: [
            'Inutilizado por erro de impressão',
            'Inutilizado no manuseio',
            'Extraviado após recebimento',
            'Recebido com defeito',
            'Furtado ou roubado',
            'Inutilizado por calamidade',
            'Impresso em outro sistema'
          ],
          motivo: null,
          show: false,
          item: {}
        },
        modalDetalhes: {
          show: false,
          item: {}
        },
        lote: {},
        itens: [],
        table: {
          busy: false,
          fieldsUsados: [
            { key: 'numero_serie', label: 'Número de série' },
            { key: 'key_matricula', label: 'Matricula' },
            { key: 'key_ordem_servico', label: 'Nº O.S.' },
            { key: 'key_data_hora_consumo', label: 'Data/hora consumo'},
            { key: 'key_action', label: 'Ação', tdClass: "acao-data-column" }
          ],
          fieldsCancelado: [
            { key: 'numero_serie', label: 'Número de série' },
            { key: 'motivo_cancelamento', label: 'Motivo cancelamento' },
            { key: 'key_data_hora_cancelamento', label: 'Data/hora cancelamento'},
            { key: 'key_action', label: 'Ação', tdClass: "acao-data-column" }
          ],
          fieldsAtivos: [
            { key: 'numero_serie', label: 'Número de série'},
            { key: 'key_action', label: 'Ação', tdClass: "acao-ativo-column", thClass: "acao-ativo-column" }
          ],
          fields: []
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        try {
          const response = await UsuarioService.getUsuarios()
          if (!response || !response.data) return

          this.searchStatusChange()

          this.escreventes = []
          this.digitadores = []

          this.usuarios = response.data || []

          loader({ active: true, text: 'Carregando detalhes do lote...' })
          await this.getLote()
          loader({ active: false, text: '' })

          // caso n exista lote redirecionamos para a pagina princial de lotes
          if (Object.values(this.lote).length == 0) {
            this.$router.push({ name: 'papel_seguranca_lote', params: { propErro: { status: true, message: 'O lote que tentou acessar não existe!' } } })
            return
          }

          // caso o lot exista pegamos os itens (papeis de seguranca) dele
          await this.getLoteItens()
        } catch (e) {
          console.error(e)
        }
      },
      async getLote () {
        // caso lote venha da prop utilizamos ele
        if (Object.values(this.propLote).length > 0) {
          this.lote = { ...this.propLote }
        } else {
          // caso contrario pegamos do service
          this.lote = await PapelSegurancaLoteService.show(this.$route.params.id)
        }
      },
      async getLoteItens () {
        try {
          this.table.busy = true
          const payload = {
            lote_id: this.$route.params.id,
            page: this.pagination.page,
            perPage: this.pagination.perPage,
            ...this.search
          }

          const response = await PapelSegurancaLoteItensService.getItensByLote(payload)
          this.itens = response.data
          this.pagination.lastPage = response.lastPage
          this.pagination.total = response.total
        } finally {
          this.table.busy = false
        }
      },
      showModalCancelar (item) {
        this.modalCancelamento.item = item
        this.modalCancelamento.show = true
      },
      hideModalCancelar () {
        this.modalCancelamento.show = false
        this.modalCancelamento.item = {}
      },
      async cancelItem () {
        try {
          loader({ active: true, text: 'Cancelando papel' })
          const { item } = this.modalCancelamento

          await PapelSegurancaLoteItensService.cancelItem(item)
        } finally {
          loader({ active: false, text: '' })
          this.hideModalCancelar()
          await this.getLoteItens()
        }
      },
      getUrl (lote) {
        // obj padrao de troca de rota
        let obj = { name: '', params: { id: null } }

        switch (lote.registro.tipo_registro) {
        case 'O': case 'NT':
          obj.name = 'resumo_obito'
          obj.params.id = lote.registro.obito.obito_id
          break
        case 'N':
          obj.name = 'resumo_nascimento'
          obj.params.id = lote.registro.nascimento.nascimento_id
          break
        case 'D':
          obj.name = 'resumo_habilitacao_casamento'
          obj.params.id = lote.registro.habilitacaoCasamento.habilitacao_casamento_id
          break
        case 'C': case 'CR':
          obj.name = 'resumo_casamento'
          obj.params.id = lote.registro.casamento.casamento_id
          break
        }

        return obj
      },
      async reutilizarPapel (item) {
        objSwal.question.title = `Gostaria de reutilizar o papel ${ item.numero_serie }?`
        objSwal.question.text = ''
        const status = await Swal.fire(objSwal.question)

        if (status.value) {
          try {
            loader({ active: true, text: 'Salvando...' })
            await PapelSegurancaLoteItensService.reuseItem(item)
          } catch (e) {
            console.error(e.message)
          } finally {
            loader({ active: false, text: '' })
            await this.getLoteItens()
          }
        }
      },
      changePage (page) {
        this.pagination.page = page
        this.getLoteItens()
      },
      reloadLoteItens () {
        this.pagination.page = 1
        this.getLoteItens()
        this.searchStatusChange()
      },
      searchStatusChange () {
        switch (this.search.status) {
        case 'USADO':
          this.table.fields = this.table.fieldsUsados
          break
        case 'ATIVO':
          this.table.fields = this.table.fieldsAtivos
          break
        case 'CANCELADO':
          this.table.fields = this.table.fieldsCancelado
          break
        }
      },
      resetBusca () {
        this.search.status = 'USADO'
        this.search.numero_serie = null
        this.reloadLoteItens()
      },
      showModalDetalhes (item) {
        this.modalDetalhes.item = item
        this.modalDetalhes.show = true
      },
      hideModalDetalhes () {
        this.modalDetalhes.show = false
        this.modalDetalhes.item = {}
      },
      async deleteLote () {
        try {
          const lote = { ...this.lote }
          objSwal.question.title = `Deseja excluir o lote ${ lote.prefixo_inicial + lote.numero_inicial } - ${ lote.prefixo_final + lote.numero_final }?`
          const status = await Swal.fire(objSwal.question)

          if (status.value) {
            loader({ active: true, text: 'Excluindo lote...' })
            await PapelSegurancaLoteService.delete(lote.papel_seguranca_lote_id)

            objSwal.success.title = 'Lote excluído!'
            Swal.fire(objSwal.success)
            this.$router.push({ name: 'papel_seguranca_lote' })
          }
        } catch (e) {
          objSwal.error.title = 'Atenção!'
          objSwal.error.text = e.response.data.message
          Swal.fire(objSwal.error)
        } finally {
          loader({ active: false, text: '' })
        }
      },
      async updateLote (lote) {
        try {
          loader({ active: true, text: 'Atualizando lote...' })
          const response = await PapelSegurancaLoteService.update(this.$route.params.id, lote)

          if (response.success) {
            objSwal.success.title = 'Lote salvo!'
            Swal.fire(objSwal.success)
            objSwal.success.title = ''
            this.lote = { ...response.lote }
            this.edicao.show = false
          } else {
            objSwal.error.title = 'Erro ao salvar lote'

            // se existir retorno iremos pegar a mensagem
            if (!!response.message) {
              objSwal.error.text = ErrorsPapelSegurancaLoteHelper.getError(response.message)
            }
            Swal.fire(objSwal.error)
            objSwal.error.text = ''
            objSwal.error.text = ''
          }
        } finally {
          loader({ active: false })
        }
      },
      async cancelarImpressos () {
        try {
          const lote = { ...this.lote }
          objSwal.question.title = `Deseja cancelar os impressos não utilizados ${ lote.prefixo_inicial + lote.numero_inicial } - ${ lote.prefixo_final + lote.numero_final }?`
          const status = await Swal.fire(objSwal.question)

          if (status.value) {
            loader({ active: true, text: 'Cancelando impressos não utilizados...' })
            await PapelSegurancaLoteService.cancelarImpressos(lote.papel_seguranca_lote_id)

            objSwal.success.title = 'Impressos Cancelados!'
            Swal.fire(objSwal.success)
            this.$router.push({ name: 'papel_seguranca_lote' })
          }
        } catch (e) {
          objSwal.error.title = 'Atenção!'
          objSwal.error.text = e.response.data.message
          Swal.fire(objSwal.error)
        } finally {
          loader({ active: false, text: '' })
        }
      }
    }
  }
</script>

<style lang="scss">
  .PapelSegurancaLoteDetalhes {
    &_table {
      &--header {
        background-color: #01bfa5;
      }
    }
  }

  .acao-ativo-column {
    width: 124px;
  }

  .acao-data-column {
    width: 235px;
    text-align: end !important;
  }
</style>
